/*jshint esversion: 6 */

export default class AjaxHelper {
  static getAjax(dataObject, apiHandlerFunction) {
    return $.ajax({
      method: "GET",
      url: window.location.origin + "/api/" + apiHandlerFunction,
      dataType: "JSON",
      data: dataObject
    });
  }

  static waitGetAjax(dataObject, apiHandlerFunction) {
    return $.ajax({
      method: "GET",
      async: false,
      url: window.location.origin + "/api/" + apiHandlerFunction,
      dataType: "JSON",
      data: dataObject
    });
  }

  static postAjax(dataObject, apiHandlerFunction) {
    return $.ajax({
      method: "POST",
      url: window.location.origin + "/api/" + apiHandlerFunction,
      dataType: "JSON",
      contentType: "application/json; charset=UTF-8",
      data: JSON.stringify(dataObject)
    });
  }
}
